export const EVENTS = {
    SWUP_CLICK_LINK: 'swup:clicklink',
    SWUP_WILL_REPLACE_CONTENT: 'swup:willreplacecontent',
    SWUP_CONTENT_REPLACED: 'swup:contentreplaced',
    MODAL_OPEN: 'modal:open', //natvrdo v Modal.js
    MODAL_CLOSE: 'modal:close', //natvrdo v Modal.js
    MODALOPENER_CLICK: 'modalopener:click', //natvrdo v ModalOpener.js
    POPUPNAV_OPENED: 'popupnav:opened',
    POPUPNAV_CLOSED: 'popupnav:closed',
    POPUPNAV_TOGGLE: 'popupnav:toggle',
    DOM_CHANGE: 'dom:change',
    SECTIONOBSERVER_SECTIONCHANGE: 'sectionobserver:sectionchange',
}